export const emergencyContacts = [
    { id: 1, name: 'Lagos State Emergency', number: '112', type: 'Hotline' },
    { id: 2, name: 'Police (Lagos)', number: '767', type: 'Police' },
    { id: 3, name: 'Ambulance (LASAMBUS)', number: '0800 5272 6287', type: 'Medical' },
    { id: 4, name: 'Fire Service', number: '0803 323 0500', type: 'Fire' },
];

export const hospitals = [
    { id: 1, name: 'Reddington Hospital', area: 'Victoria Island', is24hr: true, type: 'Private', phone: '+234 1 271 5341' },
    { id: 2, name: "St. Nicholas Hospital", area: 'Lagos Island', is24hr: true, type: 'Private', phone: '+234 1 461 3450' },
    { id: 3, name: "LUTH", area: 'Idi-Araba', is24hr: true, type: 'Public', phone: '+234 1 585 0737' },
    { id: 4, name: 'Ikeja Medical Centre', area: 'Ikeja', is24hr: true, type: 'Private' },
    { id: 5, name: 'Evercare Hospital', area: 'Lekki Phase 1', is24hr: true, type: 'Private' },
    { id: 6, name: 'Paelon Memorial', area: 'Ikeja', is24hr: true, type: 'Private' },
    { id: 7, name: 'Lagoon Hospital', area: 'Ikoyi', is24hr: true, type: 'Private' },
    { id: 8, name: 'Military Hospital', area: 'Yaba', is24hr: true, type: 'Public' },
    { id: 9, name: 'First Cardiology', area: 'Ikoyi', is24hr: true, type: 'Private' },
    { id: 10, name: 'Lekki Medical Centre', area: 'Lekki', is24hr: true, type: 'Private' },
];

export const pharmacies = [
    { id: 1, name: 'Medplus Pharmacy', area: 'Lekki', is24hr: true, delivery: true },
    { id: 2, name: 'HealthPlus', area: 'Ikeja City Mall', is24hr: false, delivery: true },
    { id: 3, name: 'Nett Pharmacy', area: 'Victoria Island', is24hr: true, delivery: true },
];

export const doctors = [
    { id: 1, name: 'Dr. Adewale K. Solomon', specialty: 'General Practitioner', languages: ['Yoruba', 'English'], fee: 5000, photo: 'https://i.pravatar.cc/150?u=dr1' },
    { id: 2, name: 'Dr. Chidinma Okafor', specialty: 'Pediatrician', languages: ['Igbo', 'English'], fee: 7500, photo: 'https://i.pravatar.cc/150?u=dr2' },
];

export const providers = [
    {
        id: 1, name: 'Segun Arinze', category: 'Drivers', area: 'Ikeja', verified: true,
        photo: 'https://i.pravatar.cc/150?u=p1', rate: 15000,
        passengers: 3, suitcases: 2, type: 'Sedan',
        packages: [{ name: 'Full Day (8hrs)', price: 15000 }, { name: 'Weekly', price: 90000 }],
        reviews: { cost: 4.8, quality: 4.9, service: 5.0, punctuality: 4.7 }
    },
    {
        id: 101, name: 'Lagos VIP Suvs', category: 'Drivers', area: 'Lekki', verified: true,
        photo: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?auto=format&fit=crop&q=80&w=200', rate: 35000,
        passengers: 6, suitcases: 5, type: 'SUV',
        packages: [{ name: 'Airport Pickup', price: 20000 }, { name: 'Full Day', price: 45000 }],
        reviews: { cost: 4.5, quality: 4.9, service: 4.9, punctuality: 4.8 }
    },
    {
        id: 102, name: 'Eko Group Shuttles', category: 'Drivers', area: 'VI', verified: true,
        photo: 'https://images.unsplash.com/photo-1556885516-7788cdcdedaa?auto=format&fit=crop&q=80&w=200', rate: 45000,
        passengers: 12, suitcases: 10, type: 'Minibus',
        packages: [{ name: 'Group Airport Pickup', price: 30000 }, { name: 'Tour (Full Day)', price: 60000 }],
        reviews: { cost: 4.7, quality: 4.6, service: 4.8, punctuality: 4.9 }
    },
    {
        id: 2, name: 'Chef Amaka', category: 'Chefs', area: 'Lekki', verified: true,
        photo: 'https://i.pravatar.cc/150?u=p2', rate: 25000,
        packages: [{ name: 'Dinner for 2', price: 25000 }, { name: 'Party Catering', price: 150000 }],
        reviews: { cost: 4.5, quality: 5.0, service: 4.8, punctuality: 4.2 }
    },
    {
        id: 3, name: 'Bose Hairstylist', category: 'Hairstylist', area: 'VI', verified: true,
        photo: 'https://i.pravatar.cc/150?u=p3', rate: 8000,
        packages: [{ name: 'Braiding', price: 12000 }, { name: 'Wig Install', price: 8000 }],
        reviews: { cost: 4.9, quality: 4.7, service: 4.9, punctuality: 4.5 }
    },
    { id: 4, name: 'Tunde Barber', category: 'Barbers', area: 'Surulere', verified: true, photo: 'https://i.pravatar.cc/150?u=p4', rate: 3000 },
    {
        id: 5, name: 'Babatunde Swift', category: 'Logistics', area: 'Ikeja', verified: true,
        photo: 'https://images.unsplash.com/photo-1558981403-c5f97cbba6c8?auto=format&fit=crop&q=80&w=200', rate: 1500,
        type: 'Motorcycle', vehicle: 'Boxer 150',
        packages: [{ name: 'Express Delivery (Within 5km)', price: 1500 }, { name: 'Full Day Courier', price: 12000 }],
        reviews: { cost: 4.9, quality: 4.8, service: 5.0, punctuality: 4.9 }
    },
    {
        id: 6, name: 'Ayo Logistics', category: 'Logistics', area: 'Lekki', verified: true,
        photo: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?auto=format&fit=crop&q=80&w=200', rate: 4500,
        type: 'Car', vehicle: 'Toyota Corolla',
        packages: [{ name: 'Point-to-Point Pickup', price: 4500 }, { name: 'Moving Van Service', price: 35000 }],
        reviews: { cost: 4.7, quality: 4.9, service: 4.8, punctuality: 4.6 }
    },
];

export const restaurants = [
    { id: 1, name: 'The Place', cuisine: 'Nigerian', budget: '$$', area: 'Lekki', rating: 4.2 },
    { id: 2, name: 'Yellow Chilli', cuisine: 'African Fusion', budget: '$$$', area: 'VI', rating: 4.5 },
    { id: 3, name: 'Nok by Alara', cuisine: 'Fine Dining', budget: '$$$$', area: 'VI', rating: 4.8 },
    { id: 4, name: 'Shiro', cuisine: 'Asian', budget: '$$$$', area: 'VI', rating: 4.7 },
    { id: 5, name: 'Ocean Basket', cuisine: 'Seafood', budget: '$$$', area: 'Ikeja', rating: 4.3 },
];

export const trainRoutes = [
    { id: 1, from: 'Lagos (Mobolaji Johnson)', to: 'Ibadan (Moniya)', time: '08:00 AM', price: 3500 },
    { id: 2, from: 'Lagos (Mobolaji Johnson)', to: 'Ibadan (Moniya)', time: '04:00 PM', price: 3500 },
    { id: 3, from: 'Lagos (Mobolaji Johnson)', to: 'Abeokuta', time: '08:00 AM', price: 2000 },
];

export const guides = [
    { title: 'Transport', content: 'Lagos transport includes Danfo buses, Uber/Bolt, and the new Blue Line Rail.' },
    { title: 'Safety', content: 'Stick to well-lit areas. Use verified EZ Drivers for night trips.' },
    { title: 'Money', content: 'NGN is the currency. Use Opay or Palmpay via the EZ Wallet for local payments.' },
    { title: 'Connectivity', content: 'MTN and Airtel lead. You can order a mock eSIM in the Wallet tab.' },
];

export const summerSchools = [
    { id: 1, name: 'Lagos Prep Summer Camp', area: 'Ikoyi', ages: '5-12', duration: '4 weeks', tuition: '₦50,000 - ₦150,000' },
    { id: 2, name: 'British International Summer', area: 'VI', ages: '11-16', duration: '2 weeks', tuition: '₦200,000+' },
];

export const domesticWorkers = [
    { id: 1, name: 'Blessing Udoh', role: 'Nanny', education: 'ND (Public Admin)', experience: '4 years', status: 'Security Cleared', verified: true, photo: 'https://i.pravatar.cc/150?u=dw1', rate: 60000, skills: ['Childcare', 'Cooking'] },
];

export const tutors = [
    { id: 1, name: 'Mr. John Obi', subjects: ['Maths', 'Physics'], education: 'B.Sc Engineering', rate: 3000, photo: 'https://i.pravatar.cc/150?u=t1' },
];

export const sponsoredEssential = [
    { id: 's1', name: 'Segun Arinze', category: 'Drivers', photo: 'https://i.pravatar.cc/150?u=p1', rate: 15000, verified: true },
    { id: 's2', name: 'Babatunde Swift', category: 'Logistics', photo: 'https://images.unsplash.com/photo-1558981403-c5f97cbba6c8?auto=format&fit=crop&q=80&w=200', rate: 1500, verified: true },
    { id: 's3', name: 'Ayo Logistics', category: 'Logistics', photo: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?auto=format&fit=crop&q=80&w=200', rate: 4500, verified: true },
    { id: 's4', name: 'Chauffeur VIP', category: 'Drivers', photo: 'https://images.unsplash.com/photo-1556885516-7788cdcdedaa?auto=format&fit=crop&q=80&w=200', rate: 45000, verified: true }
];

export const sponsoredExplore = [
    { id: 's11', name: 'Chef Amaka', category: 'Chefs', photo: 'https://i.pravatar.cc/150?u=p2', rate: 25000, verified: true },
    { id: 's12', name: 'Nok by Alara', category: 'Restaurant', photo: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&q=80&w=200', rate: 15000, verified: true },
    { id: 's13', name: 'Lagos City Tours', category: 'Guides', photo: 'https://images.unsplash.com/photo-1552832230-c0197dd311b5?auto=format&fit=crop&q=80&w=200', rate: 10000, verified: true },
    { id: 's14', name: 'Bose Hairstylist', category: 'Hairstylist', photo: 'https://i.pravatar.cc/150?u=p3', rate: 8000, verified: true }
];

export const sponsoredTravel = [
    { id: 's21', name: 'Eko Hotels', category: 'Hotels', photo: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&q=80&w=200', rate: 120000, verified: true },
    { id: 's22', name: 'Uber VIP', category: 'Taxi', photo: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?auto=format&fit=crop&q=80&w=200', rate: 5000, verified: true },
    { id: 's23', name: 'Shortstay Lekki', category: 'Shortstay', photo: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&q=80&w=200', rate: 85000, verified: true },
    { id: 's24', name: 'NRC Premium', category: 'Trains', photo: 'https://images.unsplash.com/photo-1541427468627-a89a96e5ca1d?auto=format&fit=crop&q=80&w=200', rate: 6000, verified: true }
];

export const allSponsoredAds = [...sponsoredEssential, ...sponsoredExplore, ...sponsoredTravel];
